import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { FormikHelpers } from 'formik';
import { notify } from '../../../common/utils/notification';

import { useCreateActionUrl } from '../api/useCreateActionUrl';
import { useGetActionUrls } from '../api/useGetActionUrls';
import { hasTriggerConflict } from '../utils/validateTriggerConflict';
import { ActionUrlForm } from './action-url-form/ActionUrlForm';
import { IActionUrlForm } from '../types/ActionUrl';

import cardStyles from '../../../../theme/styles/Card.module.css';

export const CreateActionUrlFrom = () => {
  const queryClient = useQueryClient();
  const { isLoading, mutate } = useCreateActionUrl();
  const { isSuccess, data: actionUrlData } = useGetActionUrls();
  const { t } = useTranslation();

  const submit = (data: IActionUrlForm, helpers: FormikHelpers<IActionUrlForm>) => {
    if (!actionUrlData?.items || !isSuccess) {
      return;
    }

    const hasConflict = hasTriggerConflict(data, actionUrlData.items);

    if (hasConflict) {
      return notify.error(t('common:actionUrlDuplicateError'), {
        duration: 6000,
        position: 'bottom-right',
        style: {
          marginRight: '8px'
        },
      });
    }

    mutate(data, {
      onSuccess: () => {
        void queryClient.invalidateQueries(['actionUrl/getAll']);
        helpers.resetForm();
      }
    })
  };

  return (
    <div>
      <div className={cardStyles.card_content} style={{ overflow: 'hidden' }}>
        <ActionUrlForm
          disabledActions={isLoading}
          onSubmit={submit}
        />
      </div>
    </div>
  );
};
